import {inject, Injectable} from "@angular/core";
import {OrgBUProjectTeamStructure} from "../../../models/custom-models/org-buproject-team-structure";
import {SecureStorageService} from "../../core/services/secure-storage.service";
import {LocalStorageRelatedData} from "../../../local-storage-related-data.model";

@Injectable({
    providedIn: "root",
})
export class ViewTaskSelectionHandlingService {
    private secureStorageService = inject(SecureStorageService)
    constructor() {
    }

    storeTaskSelectedEntityToLocal(entity: OrgBUProjectTeamStructure | null) {
        entity
            ? this.secureStorageService.setSessionItem(LocalStorageRelatedData.SessionStorage.VIEW_TASK_TEAM_SELECTED_ENTITY, entity)
            : this.secureStorageService.removeSessionItem(LocalStorageRelatedData.SessionStorage.VIEW_TASK_TEAM_SELECTED_ENTITY);
    }

    getViewTaskSelectedEntityFromLocal() {
        return this.secureStorageService.getSessionItem<OrgBUProjectTeamStructure>(LocalStorageRelatedData.SessionStorage.VIEW_TASK_TEAM_SELECTED_ENTITY) ? this.secureStorageService.getSessionItem<OrgBUProjectTeamStructure>(LocalStorageRelatedData.SessionStorage.VIEW_TASK_TEAM_SELECTED_ENTITY) : null;
    }
}
